<template>
  <div class="tabs__model5">
    <b-card no-body class="row m-0">
      <b-tabs card v-model="tabindex">
        <b-tab
          active
          :id="detail && detail.freightMode === 'AIR' ? 'tab__purple' : detail && detail.freightMode === 'LAND' ? 'tab__deepgreen' : ''"
          >
          <template #title>
            <span class="d-flex align-items-center justify-content-center">
              <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-bottom: 3px; margin-right: 2px;">
                <path d="M6.95902 9.79861C8.99402 9.79861 10.643 7.79861 10.643 5.32361C10.643 2.84861 10.102 0.849609 6.95902 0.849609C3.81602 0.849609 3.27502 2.84961 3.27502 5.32461C3.27502 7.79961 4.92402 9.79861 6.95902 9.79861Z" :fill="tabindex === 0 ? '#FFFFFF' : '#636363'"/>
                <path d="M13.91 16.4506C13.842 12.1456 13.28 10.9186 8.97701 10.1426C8.4226 10.6397 7.70416 10.9146 6.95951 10.9146C6.21485 10.9146 5.49641 10.6397 4.94201 10.1426C0.686005 10.9106 0.0900049 12.1196 0.0120049 16.3106C0.00600485 16.6526 0.00300708 16.6706 0.00100708 16.6316V17.0836C0.00100708 17.0836 1.02501 19.1486 6.95901 19.1486C12.893 19.1486 13.917 17.0836 13.917 17.0836V16.7486C13.9093 16.6494 13.907 16.55 13.91 16.4506Z" :fill="tabindex === 0 ? '#FFFFFF' : '#636363'"/>
              </svg>

              <small class="directchat__topcontent--text pl-1">{{totalActiveUser}}</small>
              <div @click="showUserList = !showUserList" style="width: 88%; cursor: pointer;"
              class="d-flex align-items-center">
                <strong class="directchat__topcontent--text">CHAT ROOM</strong>
                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.838 8.17969H12.608H6.99799C6.03799 8.17969 5.55799 9.33969 6.23799 10.0197L11.418 15.1997C12.248 16.0297 13.598 16.0297 14.428 15.1997L16.398 13.2297L19.608 10.0197C20.278 9.33969 19.798 8.17969 18.838 8.17969Z" :fill="tabindex === 0 ? '#FFFFFF' : '#636363'"/>
                </svg>
              </div>
            </span>
            <div class="directchat__topcontent">
                <div class="d-flex align-items-center justify-content-center">
                </div>
                <transition name="fade">
                  <div class="col-md user__list" v-if="showUserList">
                    <div class="row m-0 pt-3">
                      <div class="col-md-6 p-0">
                        <div class="d-flex justify-content-between pt-3 pr-5">
                          <b>Active User</b>
                          <p>:</p>
                        </div>
                      </div>
                      <div class="col-md-3 p-2 text-center" :id="`active-user-${i}`" v-for="(item, i) in activeUser" :key="i">
                        <img src="@/assets/image/image/Customer Default Photo.png" alt="">
                        <div class="user__list--text">
                          <p>{{item.role | TitleCase}}</p>
                          <p>{{item.user}}</p>
                        </div>
                        <b-tooltip id="chat-user" :target="`active-user-${i}`" placement="bottomright" class="text-center">
                          <b>{{ item.role | TitleCase}}</b>
                          <p>{{item.name}} <br> {{item.user}} <br> {{item.phone}} </p>
                        </b-tooltip>
                      </div>
                    </div>
                    <div class="row m-0">
                      <div class="col-md-6 p-0">
                        <div class="d-flex justify-content-between pt-3 pr-5">
                          <b>Pending Invitation</b>
                          <p>:</p>
                        </div>
                      </div>
                      <div  class="col-md-3 p-2 text-center" :id="`pending-user-${i}`" v-for="(item, i) in pendingUser" :key="i">
                        <img style="filter: grayscale(1);" src="@/assets/image/image/Customer Default Photo.png" alt="">
                        <div class="user__list--text">
                          <p>{{item.role | TitleCase}}</p>
                          <p>{{item.user}}</p>
                        </div>
                        <b-tooltip id="chat-user" :target="`pending-user-${i}`" placement="bottomright" class="text-center">
                          <b>{{ item.role | TitleCase}}</b>
                          <p>{{item.name}} <br> {{item.user}} <br> {{item.phone}} </p>
                        </b-tooltip>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
          </template>
          <b-card-text>
            <div class="directchat">
              <div class="directchat__content">
                <div class="align-items-end h-100">
                  <div class="col-md text-center" v-if="isLoadingMessages">
                    <b-spinner small variant="secondary"></b-spinner>
                  </div>
                  <div class="col-md p-0 test h-100">
                    <div class="box__chatting global__scrollcustom" v-chat-scroll="{smooth: true, notSmoothOnInit: true}">
                      <div :class="getBubbleRowClass(message.sender.username)"  v-for="(message, index) in messages" :key="`${index}-A`">
                        <div :class="getBubbleColClass(message.sender.username)">
                          <div :class="getBubbleContent(message.sender.username)">
                            <!-- admin bubble -->
                            <div class="bubble__icon text-center"
                                  v-if="message.sender.username !== profile.customerUsername">
                              <img class="" v-if="message.sender.comptp === 'GUEST'"
                              src="@/assets/image/image/Customer Default Photo.png" alt="">
                              <img class="" v-else-if="message.sender.comptp === 'VENDOR'"
                              src="@/assets/image/image/Vendor Default Photo.png" alt="">
                              <img class="" v-else
                              src="@/assets/image/image/Admin Default Photo.png" alt="">
                              <p class="bubble__username">
                                  {{ message.sender.fullname ? message.sender.fullname
                                  : message.sender.username }}
                              </p>
                            </div>
                            <!-- end admin bubble -->
                            <div :class="getBubbleSizeClass(message.sender.username)">
                              <p :class="message.sender.username === profile.customerUsername
                                          ? 'time__bubble2' : 'time__bubble'">
                                {{ getMessageDate(message.createdAt) }}
                                <span>{{ getMessageTime(message.createdAt) }}</span>
                              </p>
                              <div :class="getBubbleColorClass(message.sender.username)">
                                <div class="d-flex flex-row uploadfile"
                                v-if="message.attachment !== null">
                                  <img :class="message.sender.username === profile.customerUsername
                                    ? 'uploadfile__icon' : ''" @click.prevent="downloadDoc(message.shipmentId, message.orderNumber, message.attachment.type.split('/')[ 0 ], message.attachment.type.split('/')[ 1 ], message.attachment.fileId)"
                                    :src="getIconFile(message.attachment.type)" alt="" height="28px">
                                  <div class="uploadfile pl-3">
                                    <p :class="message.sender.username === profile.customerUsername
                                          ? 'uploadfile__desc' : 'uploadfile__desc2'">
                                          File Name: {{ message.attachment.type.replace("/","") }}</p>
                                    <p :class="message.sender.username === profile.customerUsername
                                          ? 'uploadfile__desc' : 'uploadfile__desc2'">
                                        File Category: {{ message.attachment.fileDesc }}</p>
                                  </div>
                                </div>
                                <div v-if="message.attachment === null"
                                      :class="message.sender.username === profile.customerUsername
                                      ? 'bubble__text2' : 'bubble__text'">
                                  <div v-if="message.replyOf && message.replyOf.body">
                                    <div class="row m-0 reply__mesage">
                                      <span>{{message.replyOf.from}}:</span>
                                      <span class="pl-1">{{message.replyOf.body}}</span>
                                    </div>
                                    {{removeOldReply(message.body)}}
                                  </div>
                                  <div v-else>{{message.body}}</div>
                                </div>
                                <!-- v-show="isHoveReplyMsg == index" -->
                                <div :class="message.sender.username === profile.customerUsername
                                      ? 'bubble__reply2' : 'bubble__reply'"
                                      @click.prevent="repplyMessages(message)">
                                  <img src="@/assets/image/icon/message-reply-arrow.svg" alt="">
                                  <p>Reply</p>
                                </div>
                              </div>
                            </div>
                            <!-- your bubble -->
                            <div class="bubble__icon mr-3 text-center"
                                  v-if="message.sender.username === profile.customerUsername">
                              <img class="" v-if="message.sender.comptp === 'USER'"
                              src="@/assets/image/image/Customer Default Photo.png" alt="">
                              <img class="" v-else-if="message.sender.comptp === 'VENDOR'"
                              src="@/assets/image/image/Vendor Default Photo.png" alt="">
                              <img class="" v-else
                              src="@/assets/image/image/Admin Default Photo.png" alt="">
                              <p class="bubble__username2">
                                {{ message.sender.fullname ? message.sender.fullname
                                : message.sender.username }}
                              </p>
                            </div>
                            <!-- end your bubble -->

                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="isReplyMsg" class="directchat__content--reply">
                      <span class="close" @click="resetMessage()">&times;</span>
                      <div class="reply__container">
                        <h5>{{replyOf.from}}</h5>
                        <h6>{{removeOldReply(replyOf.body)}}</h6>
                      </div>
                    </div>
                    <form id="sendmessages" @submit.prevent="sendMessages()">
                      <div class="row m-0 directchat__content--send">
                        <div class="col-md input">
                          <div class="row m-0 input__container">
                            <b-form-textarea class=""
                              v-on:keyup="validateEmailAddress"
                              max-rows="3" v-model="text"
                              placeholder="Enter your message">
                            </b-form-textarea>
                            <div class="input__button">
                              <div class="button__upload">
                                <img src="@/assets/image/icon/chat-attachment.svg" alt=""
                                      @click="uploadfile()">
                              </div>
                              <button type="submit" name="button"
                                class="button__bluecorporite"
                                :disabled="removelinebreaks(text) === ''">
                                <img class=""  src="@/assets/image/icon/next.svg" alt="">
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>
        <b-tab 
          title="Email" 
          :id="detail && detail.freightMode === 'AIR' ? 'tab__purple' : detail && detail.freightMode === 'LAND' ? 'tab__deepgreen' : ''"
          >
          <template #title>
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 13.5C3.24 13.5 1 15.73 1 18.5C1 21.27 3.24 23.5 6 23.5C8.76 23.5 11 21.26 11 18.5C11 15.74 8.77 13.5 6 13.5ZM3.96 16.46H6C6.38 16.46 6.68 16.77 6.68 17.14C6.68 17.51 6.38 17.82 6 17.82H3.96C3.58 17.82 3.28 17.51 3.28 17.14C3.28 16.77 3.58 16.46 3.96 16.46ZM8.04 20.54H3.96C3.58 20.54 3.28 20.23 3.28 19.86C3.28 19.49 3.59 19.18 3.96 19.18H8.05C8.43 19.18 8.73 19.49 8.73 19.86C8.73 20.23 8.42 20.54 8.04 20.54Z" :fill="tabindex === 1 ? 'white' :'#6E6E6E'"/>
              <path d="M17 3.5H7C4 3.5 2 5 2 8.5V11.64C2 12.37 2.75 12.83 3.42 12.54C4.52 12.06 5.77 11.88 7.08 12.09C9.7 12.52 11.84 14.59 12.37 17.19C12.52 17.95 12.54 18.69 12.44 19.4C12.36 19.99 12.84 20.51 13.43 20.51H17C20 20.51 22 19.01 22 15.51V8.5C22 5 20 3.5 17 3.5ZM17.47 9.09L14.34 11.59C13.68 12.12 12.84 12.38 12 12.38C11.16 12.38 10.31 12.12 9.66 11.59L6.53 9.09C6.21 8.83 6.16 8.35 6.41 8.03C6.67 7.71 7.14 7.65 7.46 7.91L10.59 10.41C11.35 11.02 12.64 11.02 13.4 10.41L16.53 7.91C16.85 7.65 17.33 7.7 17.58 8.03C17.84 8.35 17.79 8.83 17.47 9.09Z" :fill="tabindex === 1 ? 'white' :'#6E6E6E'"/>
            </svg>
            <strong class="directchat__topcontent--text">EMAIL</strong>
          </template>
          <b-card-text>
            <GroupChatEmail
              :requestID="shipmentId"
              :requestNumber="orderNumber"
              :referenceNumber="referenceNumber"
              :requestType="'SHIPMENT'"
              :shipmentService="shipmentService"
              :tabindex="tabindex"
            />
          </b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as moment from 'moment'
import * as momentTimezone from 'moment-timezone'
import DOMPurify from 'dompurify'
import GroupChatEmail from '@/components/global/GroupChatEmail.vue'

export default {
  name: 'DirectChat',
  components: {
    GroupChatEmail
  },
  data () {
    return {
      text: '',
      isReplyMsg: false,
      replyOf: {
        body: '',
        from: ''
      },
      shipmentId: parseInt(this.$route.params.id_shipment, 10),
      orderNumber: this.$route.params.order_number,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      checkdate: '',
      theday: '',
      totalActiveUser: 0,
      showUserList: false,
      shipmentService: '',
      tabindex: 0,
      referenceNumber: '',
    }
  },
  computed: {
    ...mapGetters({
      // get user logged profile
      profile: 'auth/profile',
      // get chat messages
      messages: 'chat/messages',
      isLoadingMessages: 'chat/isLoadingMessages',
      errorMessages: 'chat/errorMessages',
      // get chat subscribers
      subscribers: 'chat/subscribers',
      isLoadingFetchSubscribers: 'chat/isLoadingFetchSubscribers',
      errorFetchSubscribers: 'chat/errorFetchSubscribers',
      // post chat subscribers
      isLoadingPostSubscribers: 'chat/isLoadingPostSubscribers',
      errorPostSubscribers: 'chat/errorPostSubscribers',
      // get detail shipment
      detail: 'shipment/item',
      isLoading: 'shipment/isLoading',
      isError: 'shipment/error',
      // active user
      activeUser: 'shipment/activeUser',
      isLoadingActiveUser: 'shipment/isLoadingActiveUser',
      errorActiveUser: 'shipment/errorActiveUser',
      // pending user
      pendingUser: 'shipment/pendingUser',
      isLoadingPendingUser: 'shipment/isLoadingPendingUser',
      errorPendingUser: 'shipment/errorPendingUser'

    })
  },
  watch: {
    '$route.params.shipment_id': function () {
      this.fetchChannelSubscribers()
    },
    subscribers (data) {
      if (data.length === 0) {
        this.postSubscribers()
      } else {
        this.fetchChannels()
      }
    },
    activeUser (data) {
      if (data && data.length > 0) {
        this.totalActiveUser = data.length
      }
    },
    detail(data){
      if (data) {
        this.shipmentService = data.freightMode
        this.referenceNumber = data.referenceNumber.replace('/', '-')
      }
    },
    tabindex(data) {
      if (data === 1) {
        this.showUserList = false
      }
    }
  },
  mounted () {
    this.fetchChannelSubscribers()
    this.fetchActiveUser()
    this.fetchPendingUser()
  },
  methods: {
    validateEmailAddress (event) { // use shift + enter for break line, use enter for send
      if (event.keyCode === 13 && event.shiftKey === false) {
        this.sendMessages()
      }
    },
    removelinebreaks (text) {
      return text.replace(/[\r\n]+/gm, '')
    },
    uploadfile: function () {
      this.$eventHub.$emit('dialog-mgshipement-upload', {id: this.shipmentId, referenceNumber: this.orderNumber.split('-').join('/'), type: 'SHIPMENT'})
    },
    fetchActiveUser () {
      this.$store.dispatch('shipment/FETCH_ACTIVE_USER', this.shipmentId)
    },
    fetchPendingUser () {
      this.$store.dispatch('shipment/FETCH_PENDING_USER', this.shipmentId)
    },
    getRowClass (username) {
      return username !== this.profile.customerUsername ? 'row ml-0 content__merchant' : 'row justify-content-end content__customer'
    },
    getBubbleRowClass (username) {
      return username !== this.profile.customerUsername ? 'content__merchant' : 'content__customer d-flex justify-content-end'
    },
    getBubbleColClass (username) {
      return username !== this.profile.customerUsername ? 'col-md p-0 pl-3' : 'col-md p-0'
    },
    getBubbleContent (username) {
      return username !== this.profile.customerUsername ? 'content__customer row m-0 mb-5 justify-content-start' : 'content__customer row justify-content-end m-0 mb-5'
    },
    getBubbleSizeClass (username) {
      return username !== this.profile.customerUsername ? 'content__customer bubble' : 'content__customer bubble bubblemargin'
    },
    getBubbleColorClass (username) {
      return username !== this.profile.customerUsername ? 'bg__gray' : 'bg__blue'
    },
    getLoggedUser (fullname, userName, comptp) {
      let username = ''
      if (userName === this.profile.customerUsername && comptp !== 'GUEST') {
        username = this.profile.customerName
      } else if (userName === this.profile.customerUsername && comptp === 'GUEST') {
        username = this.profile.customerName || this.profile.customerUsername
      } else {
        username = fullname || userName
      }
      return username
    },
    getMessageTime (date) {
      const newTime = momentTimezone(date).tz(this.timezone).format('HH:mm')
      return newTime
    },
    getMessageDate (date) {
      const newDate = momentTimezone(date).tz(this.timezone).format('DD MMM YYYY')
      const today = momentTimezone().tz(this.timezone).format('DD MMM YYYY')
      if (today === newDate) {
        return 'Today'
      } else {
        return newDate
      }
    },
    getDate (date) {
      return moment(date).format('ddd, MMM DD')
    },
    checkDate (date) {
      if (moment(this.getDate(date), 'ddd, MMM DD').isValid()) {
        const iscurrentDate = moment(date).isSame(moment(), 'day')
        const duration = moment.duration({'days': 1})
        const isyesterday = moment(duration).isBefore(moment(), 'day')
        if (iscurrentDate) {
          return 'Today'
        } else if (isyesterday) {
          return 'Yesterday'
        } else {
          return this.getDate(date)
        }
      } else {
        return 'not found'
      }
    },
    showdate (date) {
      if (this.theday !== date) {
        this.theday = date
        return true
      } else {
        // this.theday = date
        return false
      }
    },
    fetchChannels () {
      const token = localStorage.getItem('token')
      const shipmentId = this.shipmentId
      const orderNumber = this.orderNumber.split('-').join('/')
      this.$store.dispatch('chat/WEBSOCKET_FETCH_CHANNELS', { token, shipmentId, orderNumber }).then(() => {
        this.fetchMessages()
      })
    },
    fetchChannelSubscribers () {
      const shipmentId = this.shipmentId
      const orderNumber = this.orderNumber
      const typeMessage = 'shipment'
      this.$store.dispatch('chat/WEBSOCKET_FETCH_CHANNELS_SUBSCRIBERS', {shipmentId, orderNumber, typeMessage})
    },
    fetchMessages () {
      const shipmentId = this.shipmentId
      const orderNumber = this.orderNumber
      const typeMessage = 'shipment'
      this.$store.dispatch('chat/WEBSOCKET_FETCH_MESSAGES', {shipmentId, orderNumber, typeMessage})
    },
    postSubscribers () {
      const typeMessage = 'shipment'
      const payload = {
        shipmentId: parseInt(this.shipmentId, 10),
        orderNumber: this.orderNumber.split('-').join('/')
      }
      this.$store.dispatch('chat/WEBSOCKET_POST_CHANNELS_SUBSCRIBERS', { payload, typeMessage }).then(() => {
        this.fetchChannels()
      })
    },
    getIconFile (formatfile) {
      const format = formatfile ? formatfile.split('/.')[1] : ''
      let currentIcon = ''
      switch (format.toLowerCase()) {
        case 'doc':
          currentIcon = require('@/assets/image/icon/file-format-symbol-doc.svg')
          break
        case 'docx':
          currentIcon = require('@/assets/image/icon/file-format-symbol-docx.svg')
          break
        case 'exe':
          currentIcon = require('@/assets/image/icon/file-format-symbol-exe.svg')
          break
        case 'gif':
          currentIcon = require('@/assets/image/icon/file-format-symbol-gif.svg')
          break
        case 'jpeg':
          currentIcon = require('@/assets/image/icon/file-format-symbol-jpeg.svg')
          break
        case 'jpg':
          currentIcon = require('@/assets/image/icon/file-format-symbol-jpg.svg')
          break
        case 'pdf':
          currentIcon = require('@/assets/image/icon/file-format-symbol-pdf.svg')
          break
        case 'png':
          currentIcon = require('@/assets/image/icon/file-format-symbol-png.svg')
          break
        case 'ppt':
          currentIcon = require('@/assets/image/icon/file-format-symbol-ppt.svg')
          break
        case 'pptx':
          currentIcon = require('@/assets/image/icon/file-format-symbol-pptx.svg')
          break
        case 'rar':
          currentIcon = require('@/assets/image/icon/file-format-symbol-rar.svg')
          break
        case 'xls':
          currentIcon = require('@/assets/image/icon/file-format-symbol-xls.svg')
          break
        case 'xlsx':
          currentIcon = require('@/assets/image/icon/file-format-symbol-xlsx.svg')
          break
        case 'zip':
          currentIcon = require('@/assets/image/icon/file-format-symbol-zip.svg')
          break
        default:
          break
      }
      return currentIcon
    },
    resetMessage () {
      this.replyOf.from = ''
      this.replyOf.body = ''
      this.isReplyMsg = false
    },
    repplyMessages (message) {
      this.replyOf.body = message.body
      this.replyOf.from = message.sender.fullname
        ? message.sender.fullname : message.sender.username
      this.isReplyMsg = true
    },
    removeOldReply (message) { // remove tag just for display
      if (message.split('</p>')) {
        const arrBodysplittag = message.split('</p>')
        return arrBodysplittag[arrBodysplittag.length - 1]
      }
      return message
    },
    sendMessages () {
      if (this.removelinebreaks(this.text) !== '') {
        const typeMessage = 'shipment'
        const messageBody = DOMPurify.sanitize(this.text)
        const replyOf = Object.assign({}, this.replyOf)
        const payload = {
          messageBody,
          shipmentId: parseInt(this.shipmentId, 10),
          orderNumber: this.orderNumber.split('-').join('/'),
          reply: { to: 'admin' },
          replyOf
        }
        this.$store.dispatch('chat/WEBSOCKET_SEND_MESSAGE', { payload, typeMessage })
        this.messages.push({
          sender: {
            username: this.profile.customerUsername,
            fullname: this.profile.customerName,
            createdAt: moment().format('YYYY-MM-DDTHH:mm:ssZ'),
            comptp: this.profile.codeUserType === 'GUEST' ? 'GUEST' : 'USER'
          },
          body: messageBody,
          replyOf: this.isReplyMsg ? replyOf : null,
          attachment: null
        })
        this.text = ''
        this.resetMessage()
      }
    },
    downloadDoc (id, orderNumber, fileCategory, fileExt, fileId) {
      const shipmentId = id
      const type = 'SHIPMENT'
      const fileName = `${fileCategory}${fileExt}`
      const splittedOrderNumber = orderNumber.split('/').join('-')
      this.$store.dispatch('shipment/DOWNLOAD_SHIPMENT_DOCUMENT', {shipmentId, orderNumber: splittedOrderNumber, type, fileName, fileCategory, fileId})
    }
  },
  sockets: {
    connect: function () {
      console.log('socket connected')
    },
    action: function (data) {
      if (data.type === 'RECEIVE_WEBSOCKET_UPDATE_SHIPMENT_MESSAGES') {
        if (data.payload.response.message.sender.username !== this.profile.customerUsername) {
          if ((data.payload.response.message.sender.comptp === 'ANDALIN' && parseInt(data.payload.response.message.shipmentId) === parseInt(this.shipmentId) && data.payload.response.message.reply.to === 'customer') ||
          (data.payload.response.message.sender.comptp === 'USER' && parseInt(data.payload.response.message.shipmentId) === parseInt(this.shipmentId) && data.payload.response.message.reply.to === 'admin') ||
          (data.payload.response.message.sender.comptp === 'GUEST' && parseInt(data.payload.response.message.shipmentId) === parseInt(this.shipmentId) && data.payload.response.message.reply.to === 'admin')) {
            this.messages.push(data.payload.response.message)
          }
        }
      }
      if (data.type === 'RECEIVE_WEBSOCKET_UPDATE_SHIPMENT_DOCUMENTS') {
        if ((data.payload.response.message.sender.comptp === 'ANDALIN' && data.payload.response.message.reply.to === 'customer' && parseInt(data.payload.response.message.shipmentId) === parseInt(this.shipmentId)) ||
        (data.payload.response.message.sender.comptp === 'USER' && data.payload.response.message.reply.to === 'admin' && parseInt(data.payload.response.message.shipmentId) === parseInt(this.shipmentId)) ||
        (data.payload.response.message.sender.comptp === 'GUEST' && data.payload.response.message.reply.to === 'admin' && parseInt(data.payload.response.message.shipmentId) === parseInt(this.shipmentId))) {
          this.messages.push(data.payload.response.message)
          this.$eventHub.$emit('dialog-mgshipement-upload-hide')
        }
      }
      console.log('this method was fired by the socket server. eg: io.emit("action", data)')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/managementShipment/detail/DirectChat.vue